import { ready } from '~/core';
import { addEvents } from '~/utils';

ready('navVert', '.navVert-group', group => {
	const toggle = group.querySelector('.navVert-trigger');
	const list = group.querySelector('.navVert-list');

	if (!toggle || !list) return

	const do_toggle = () => {
		let start, end;

		start = list.offsetHeight;
		group.classList.toggle('is-open');
		end = list.offsetHeight;

		list.animate([{ height: `${start}px` }, { height: `${end}px` }], {
			duration: 250,
			easing: 'ease',
		});
	};

	addEvents(toggle, 'click.self.prevent', do_toggle)
});
